(function () {
  "use strict";
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- toast ---------- */
  var tt;
  function toast(msg) {
    var t = $("#toastr"); if (!t) return;
    t.textContent = msg; t.classList.add("on");
    clearTimeout(tt); tt = setTimeout(function () { t.classList.remove("on"); }, 3000);
  }

  /* ---------- money ---------- */
  var FORMAT = (window.Shopify && window.Shopify.money_format) || "${{amount}}";
  function money(cents) {
    var v = cents / 100;
    var s = (v % 1 === 0) ? v.toFixed(2) : v.toFixed(2);
    return FORMAT.replace(/\{\{\s*amount[^}]*\}\}/, s);
  }

  /* ---------- mobile nav ---------- */
  var burger = $("#burger"), mnav = $("#mnav");
  if (burger && mnav) {
    burger.addEventListener("click", function () {
      var open = mnav.classList.toggle("is-open");
      burger.setAttribute("aria-expanded", String(open));
    });
  }

  /* ---------- cart count ---------- */
  function setCount(n) { $$("[data-cart-count]").forEach(function (el) { el.textContent = String(n); }); }
  function refreshCount() {
    if (!window.fetch) return;
    fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCount(c.item_count); })
      .catch(function () {});
  }

  /* ---------- bundle builder ---------- */
  var tierBtns = $$("[data-tier]");
  var rows     = $$("[data-product]");
  if (rows.length) {
    var elTier  = $("[data-sum-tier]");
    var elItems = $("[data-sum-items]");
    var elDisc  = $("[data-sum-disc]");
    var elSubLn = $("[data-sum-sub-line]");
    var elSub   = $("[data-sum-sub]");
    var elTotal = $("[data-sum-total]");
    var elPer   = $("[data-sum-per]");
    var elPerWrap = $("[data-sum-per-wrap]");
    var elAdd   = $("[data-add]");
    var elNote  = $("[data-sub-note]");
    var elHowPct = $("[data-how-pct]");
    var howIn   = $$("[data-how-input]");
    var steps   = $$("[data-ladder-step]");
    var rate = 0, tierLabel = "", tierCode = "";
    // without pouch tiers the box mirrors the store's automatic quantity discounts:
    // 2 eligible items → qty_2 %, 3 → qty_3 %, 4 → qty_4 %, 5 → qty_5 %, 6 or more → qty_6 %.
    // Like the cart, the best tier the count qualifies for is the one that applies.
    var picker = $("[data-picker]");
    var qty = {};
    [2, 3, 4, 5, 6].forEach(function (n) { qty[n] = picker ? (parseFloat(picker.dataset["disc" + n]) || 0) : 0; });
    function tierQty(btn) {
      var m = (btn.dataset.label || btn.textContent || "").match(/\d+/);
      return m ? parseInt(m[0], 10) : 1;
    }
    function tierIndexFor(n) {
      var idx = 0, best = -1;
      for (var i = 0; i < tierBtns.length; i++) {
        var q = tierQty(tierBtns[i]);
        if (q <= Math.max(n, 1) && q > best) { best = q; idx = i; }
      }
      return idx;
    }
    function tierFor(n) {
      var pct = 0;
      for (var k = 2; k <= 6; k++) { if (n >= k && qty[k] > pct) pct = qty[k]; }
      return pct;
    }
    // subscription: the row's monthly plan price first (the plan's own saving), then the
    // quantity discount on top of it — exactly how the cart works it out
    function subOn() {
      for (var i = 0; i < howIn.length; i++) { if (howIn[i].checked) return howIn[i].value === "sub"; }
      return false;
    }
    var planPct = 0;
    rows.forEach(function (row) { planPct = Math.max(planPct, parseFloat(row.dataset.planPct) || 0); });
    if (elHowPct && planPct > 0) elHowPct.textContent = elHowPct.textContent.replace(/\d+(?=\s*%)/, String(planPct));

    if (tierBtns.length) {
      var first = tierBtns[0];
      rate = parseFloat(first.dataset.rate) || 0;
      tierLabel = first.dataset.label || "";
      tierCode = first.dataset.code || "";
    }

    function render() {
      var items = 0, subtotal = 0, elig = 0, eligSub = 0, planSave = 0, sub = subOn();
      rows.forEach(function (row) {
        var q = parseInt(row.querySelector("[data-qty]").textContent, 10) || 0;
        items += q;
        var cents = parseInt(row.dataset.cents, 10) || 0;
        var unit = cents;
        if (sub && row.dataset.plan) {
          var pc = parseInt(row.dataset.planCents, 10);
          if (!isNaN(pc) && pc > 0) unit = pc;
          else unit = Math.round(cents * (1 - (parseFloat(row.dataset.planPct) || 0) / 100));
        }
        var line = q * unit;
        subtotal += line;
        planSave += q * (cents - unit);
        if (row.dataset.disc !== "0") { elig += q; eligSub += line; }
      });
      var pct = tierFor(elig);
      var off = Math.round(eligSub * pct / 100);
      if (tierBtns.length) {
        var ti = tierIndexFor(elig);
        tierBtns.forEach(function (b, i) { b.setAttribute("aria-pressed", String(i === ti)); });
        tierLabel = tierBtns[ti].dataset.label || "";
      }
      var total = subtotal - off;
      if (elTier)  elTier.textContent  = tierLabel;
      if (elItems) elItems.textContent = String(items);
      if (elDisc)  elDisc.textContent  = off ? "−" + pct + "% (" + money(off) + ")" : "None";
      if (elSubLn) elSubLn.hidden = !(sub && planSave > 0);
      if (elSub)   elSub.textContent   = planSave > 0 ? "−" + planPct + "% (" + money(planSave) + ")" : "None";
      if (elNote)  elNote.hidden = !sub;
      if (elTotal) elTotal.textContent = money(total);
      // the price per bag: the same total the customer pays, shared out over the bags in the box
      if (elPer && items > 0) elPer.textContent = money(total / items);
      if (elPerWrap) elPerWrap.hidden = items === 0;
      steps.forEach(function (s) {
        var n = parseInt(s.dataset.ladderStep, 10) || 0;
        var on = elig >= n && (n === 6 || elig < n + 1 || !qty[n + 1]);
        s.classList.toggle("is-on", on);
        s.classList.toggle("is-past", !on && elig > n);
      });
      if (elAdd) {
        elAdd.disabled = items === 0;
        elAdd.textContent = items === 0
          ? "Add at least 1 item"
          : "Add " + items + " item" + (items === 1 ? "" : "s") + " · " + money(total);
      }
    }

    tierBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        tierCode = btn.dataset.code || "";
        var list = Array.prototype.slice.call(rows);
        var counts = [], total = 0, i;
        for (i = 0; i < list.length; i++) {
          var c = parseInt(list[i].querySelector("[data-qty]").textContent, 10) || 0;
          counts.push(c); total += c;
        }
        var diff = tierQty(btn) - total;
        if (diff !== 0 && list.length) {
          var idx = 0;
          for (i = 0; i < counts.length; i++) { if (counts[i] > 0) { idx = i; break; } }
          var out = list[idx].querySelector("[data-qty]");
          out.textContent = String(Math.max(0, Math.min(20, counts[idx] + diff)));
        }
        render();
      });
    });

    howIn.forEach(function (i) { i.addEventListener("change", render); });

    rows.forEach(function (row) {
      var out = row.querySelector("[data-qty]");
      var inc = row.querySelector("[data-inc]");
      var dec = row.querySelector("[data-dec]");
      if (inc) inc.addEventListener("click", function () {
        out.textContent = String(Math.min(20, (parseInt(out.textContent, 10) || 0) + 1)); render();
      });
      if (dec) dec.addEventListener("click", function () {
        out.textContent = String(Math.max(0, (parseInt(out.textContent, 10) || 0) - 1)); render();
      });
    });

    if (elAdd) elAdd.addEventListener("click", function () {
      var payload = [];
      var missing = false;
      var sub = subOn();
      rows.forEach(function (row) {
        var q = parseInt(row.querySelector("[data-qty]").textContent, 10) || 0;
        if (!q) return;
        var id = row.dataset.variant;
        if (!id) { missing = true; return; }
        var item = { id: Number(id), quantity: q };
        if (sub && row.dataset.plan) item.selling_plan = Number(row.dataset.plan);
        payload.push(item);
      });
      if (missing && !payload.length) {
        toast("Connect these rows to products in the theme editor first");
        return;
      }
      if (!payload.length) return;
      var label = elAdd.textContent;
      elAdd.disabled = true; elAdd.textContent = "Adding…";
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ items: payload })
      })
        .then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); })
        .then(function () {
          refreshCount();
          if (missing) toast("Added. Some rows have no product connected yet.");
          if (tierCode) {
            window.location.href = "/discount/" + encodeURIComponent(tierCode) + "?redirect=/cart";
          } else {
            window.location.href = "/cart";
          }
        })
        .catch(function () {
          toast("Could not add that. Try again");
          elAdd.disabled = false; elAdd.textContent = label;
        });
    });

    render();
  }

  /* ---------- "while you ___" rotator ---------- */
  var rot = $("[data-rotate]");
  if (rot) {
    // v4.42: the phrases belong to the product being shown — read the list that is visible,
    // and start again from its first phrase whenever the product changes
    var rotWords = function () {
      var lists = $$(".whileyou__list").filter(function (l) { return l.offsetParent !== null; });
      var list = lists[0] || $(".whileyou__list");
      return list ? $$("span", list).map(function (n) { return n.textContent.trim(); }) : [];
    };
    var rotList = rotWords(), rotI = 0, rotFade, rotTick;
    var rotShow = function (w, fade) {
      clearTimeout(rotFade);
      if (!fade) { rot.textContent = w; return; }
      rot.style.opacity = "0";
      rotFade = setTimeout(function () { rot.textContent = w; rot.style.opacity = "1"; }, 220);
    };
    // the turn: restarted on a product change so the product's first phrase gets a full turn
    var rotStart = function () {
      clearInterval(rotTick);
      if (reduce) return;
      rotTick = setInterval(function () {
        if (rotList.length < 2) return;
        rotI = (rotI + 1) % rotList.length;
        rotShow(rotList[rotI], true);
      }, 2600);
    };
    if (rotList.length && rot.textContent.trim() !== rotList[0]) rotShow(rotList[0], false);
    if (!reduce) rot.style.transition = "opacity .22s ease";
    rotStart();
    if ("MutationObserver" in window) {
      new MutationObserver(function () {
        var next = rotWords();
        if (!next.length || next.join("|") === rotList.join("|")) return;
        rotList = next; rotI = 0; rotShow(next[0], !reduce); rotStart();
      }).observe(document.documentElement, { attributes: true, attributeFilter: ["data-world"] });
    }
  }

  /* ---------- FAQ: one open at a time ---------- */
  var qs = $$(".q");
  qs.forEach(function (q) {
    q.addEventListener("toggle", function () {
      if (!q.open) return;
      var grp = q.closest(".faq, [data-world-item], .pdpx");   // one open per group (each product world keeps its own)
      qs.forEach(function (o) { if (o !== q && (!grp || grp.contains(o))) o.open = false; });
    });
  });

  /* ---------- product page ---------- */
  $$("[data-thumb]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var main = $("#pdpMain");
      if (main) {
        main.src = btn.dataset.thumb;
        main.alt = btn.dataset.thumbAlt || main.alt;
        if (btn.dataset.thumbSrcset) main.srcset = btn.dataset.thumbSrcset; else main.removeAttribute("srcset");
      }
      $$("[data-thumb]").forEach(function (b) { b.setAttribute("aria-pressed", String(b === btn)); });
    });
  });

  var qtyOut = $("[data-pdp-qty]"), qtyInput = $("[data-pdp-qty-input]");
  function setQty(n) {
    n = Math.max(1, n);
    if (qtyOut) qtyOut.textContent = String(n);
    if (qtyInput) qtyInput.value = String(n);
  }
  var pInc = $("[data-pdp-inc]"), pDec = $("[data-pdp-dec]");
  if (pInc) pInc.addEventListener("click", function () { setQty((parseInt(qtyOut.textContent, 10) || 1) + 1); });
  if (pDec) pDec.addEventListener("click", function () { setQty((parseInt(qtyOut.textContent, 10) || 1) - 1); });

  var vjson = $("[data-variants]");
  if (vjson) {
    var variants = [];
    try { variants = JSON.parse(vjson.textContent); } catch (e) {}
    var groups = $$("[data-option-group]");
    var selects = $$("[data-option-selector]");
    var idField = $("[data-variant-id]"), priceEl = $("[data-price]"), addBtn = $("[data-add]");
    function chosenValues() {
      if (groups.length) {
        return groups.map(function (g) {
          var sel = g.querySelector("select");
          if (sel) return sel.value;
          var r = g.querySelector("input[type=radio]:checked");
          return r ? r.value : "";
        });
      }
      return selects.map(function (s) { return s.value; });
    }
    function update() {
      var chosen = chosenValues();
      var match = variants.filter(function (v) {
        return chosen.every(function (val, idx) { return v.options[idx] === val; });
      })[0];
      if (!match) return;
      if (idField) idField.value = match.id;
      if (priceEl) priceEl.textContent = money(match.price);
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? (addBtn.dataset.addLabel || "Add to cart") : "Sold out";
      }
      try { document.dispatchEvent(new CustomEvent("ig:variant", { detail: { id: match.id, price: match.price, available: match.available } })); } catch (err) {}
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set("variant", match.id);
        history.replaceState({}, "", url.toString());
      }
    }
    groups.forEach(function (g) { g.addEventListener("change", update); });
    selects.forEach(function (s) { s.addEventListener("change", update); });
    if (groups.length || selects.length) update();
  }

  var pform = $("#ProductForm");
  if (pform && window.fetch) {
    pform.addEventListener("submit", function (e) {
      e.preventDefault();
      var btn = pform.querySelector("[data-add]");
      var label = btn ? btn.textContent : "";
      if (btn) { btn.disabled = true; btn.textContent = "Adding…"; }
      fetch("/cart/add.js", { method: "POST", body: new FormData(pform) })
        .then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); })
        .then(function (item) {
          refreshCount();
          if (pform.dataset.after === "cart") { window.location.href = "/cart"; return; }
          var cfg = {}; try { cfg = JSON.parse((document.querySelector("[data-buy-config]") || {}).textContent || "{}"); } catch (e) {}
          toast(cfg.added || ((item.product_title || "Item") + " added to cart"));
        })
        .catch(function () { toast("Could not add that. Try again"); })
        .then(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
    });
  }
})();

/* ============================================================
   GLOWPOP v4 — nutrition panel tabs, reviews
   (the cursor is now pure CSS — see theme.css "the cursor")
   ============================================================ */
(function () {
  "use strict";
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- nutrition facts: one panel per product ---------- */
  $$("[data-nfx]").forEach(function (root) {
    var tabs   = $$("[data-nfx-tab]", root);
    var panels = $$("[data-nfx-panel]", root);
    if (tabs.length < 2) return;

    function show(key, focus) {
      tabs.forEach(function (t) {
        var on = t.dataset.nfxTab === key;
        t.setAttribute("aria-selected", String(on));
        t.setAttribute("tabindex", on ? "0" : "-1");
        if (on && focus) t.focus();
      });
      panels.forEach(function (p) { p.hidden = p.dataset.nfxPanel !== key; });
    }

    tabs.forEach(function (t) {
      t.addEventListener("click", function () { show(t.dataset.nfxTab, false); });
      t.addEventListener("keydown", function (e) {
        var i = tabs.indexOf(t), n = null;
        if (e.key === "ArrowRight" || e.key === "ArrowDown") n = tabs[(i + 1) % tabs.length];
        if (e.key === "ArrowLeft"  || e.key === "ArrowUp")   n = tabs[(i - 1 + tabs.length) % tabs.length];
        if (e.key === "Home") n = tabs[0];
        if (e.key === "End")  n = tabs[tabs.length - 1];
        if (n) { e.preventDefault(); show(n.dataset.nfxTab, true); }
      });
    });

    // start on the tab the page marked as selected (a product page pre-selects its own label)
    var pre = tabs.filter(function (t) { return t.getAttribute("aria-selected") === "true"; })[0] || tabs[0];
    show(pre.dataset.nfxTab, false);
  });

  /* ---------- reviews: show more / fewer (event delegation so it works after the editor re-renders) ---------- */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest ? e.target.closest("[data-rev-more]") : null;
    if (!btn) return;
    var sec = btn.closest("[data-rev-world]") || btn.closest(".rev"); if (!sec) return;
    var more = $$(".rcard--more", sec);
    var open = btn.getAttribute("aria-expanded") === "true";
    more.forEach(function (c) { c.hidden = open; });
    if (!btn.dataset.more) btn.dataset.more = btn.textContent;
    btn.textContent = open ? btn.dataset.more : (btn.dataset.less || "Show fewer");
    btn.setAttribute("aria-expanded", String(!open));
    if (open && more[0]) { var top = sec.getBoundingClientRect().top + window.pageYOffset - 80; window.scrollTo({ top: top, behavior: "smooth" }); }
  });
})();

/* ============================================================
   GLOWPOP v4.15 — product worlds (the switcher and its dock),
   the buy box, the Supplement Facts drawer, swipe dots
   ============================================================ */
(function () {
  "use strict";
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var root = document.documentElement;
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- money ---------- */
  var FORMAT = (window.Shopify && window.Shopify.money_format) || "${{amount}}";
  function money(cents) {
    var v = (cents / 100).toFixed(2);
    return FORMAT.replace(/\{\{\s*amount[^}]*\}\}/, v).replace(/<[^>]+>/g, "");
  }

  /* ---------- product worlds ---------- */
  var WORLDS = (window.IG_WORLDS || []).filter(function (w) { return w.on; });
  function worldDef(key) { for (var i = 0; i < WORLDS.length; i++) if (WORLDS[i].key === key) return WORLDS[i]; return null; }

  function paintWorld(key) {
    var d = worldDef(key); if (!d) return;
    root.setAttribute("data-world", key);
    root.setAttribute("data-world-color", d.color);
    $$("[data-world-pick]").forEach(function (b) { b.setAttribute("aria-selected", String(b.dataset.worldPick === key)); });
    $$("[data-world-name]").forEach(function (el) { el.textContent = d.name; });
    $$("[data-world-short]").forEach(function (el) { el.textContent = d.short || d.name; });
    $$("[data-world-link]").forEach(function (a) { if (d.url) { a.href = d.url; a.hidden = false; } else { a.hidden = true; } });
    // sections that have nothing for this world fold away; the label follows the world's product
    $$("[data-world-zone]").forEach(function (z) {
      var items = $$("[data-world-item]", z);
      if (items.length) {
        var has = items.some(function (it) { return it.dataset.worldItem === key; });
        z.classList.toggle("is-world-empty", !has);
      }
    });
    $$("[data-nfx-follow]").forEach(function (sec) {
      var panels = $$("[data-nfx-panel]", sec);
      var hit = panels.filter(function (p) { return (p.dataset.products || "").split(",").indexOf(d.handle) >= 0; })[0];
      panels.forEach(function (p) { p.hidden = p !== hit; });
      sec.classList.toggle("is-world-empty", !hit);
    });
    try { sessionStorage.setItem("ig-world", key); } catch (e) {}
  }

  var switching = null;
  function setWorld(key, opts) {
    opts = opts || {};
    if (root.hasAttribute("data-world-locked")) return;
    if (!worldDef(key) || key === root.getAttribute("data-world")) { paintWorld(key); return; }
    var zones = $$("[data-world-zone]");
    if (reduce || opts.instant) { paintWorld(key); return; }
    clearTimeout(switching);
    zones.forEach(function (z) { z.classList.add("is-switching"); });
    switching = setTimeout(function () {
      paintWorld(key);
      requestAnimationFrame(function () { zones.forEach(function (z) { z.classList.remove("is-switching"); }); });
    }, 200);
  }
  window.IG = window.IG || {};
  window.IG.setWorld = setWorld;

  // first paint: the head script chose the world; now sync the pickers and the label
  if (root.getAttribute("data-world")) paintWorld(root.getAttribute("data-world"));

  document.addEventListener("click", function (e) {
    var b = e.target.closest ? e.target.closest("[data-world-pick]") : null;
    if (!b) return;
    e.preventDefault();
    setWorld(b.dataset.worldPick);
    var rail = b.closest("[data-world-rail]");
    if (!rail) return;
  });

  /* the dock appears once the switcher has scrolled away and stays while the story sections are on screen */
  var dock = $("[data-world-dock]"), rail = $("[data-world-rail]");
  if (dock && rail) {
    var ticking = false;
    function place() {
      ticking = false;
      var zones = $$("[data-world-zone]").filter(function (z) { return !z.classList.contains("is-world-empty") && z.offsetParent !== null; });
      if (!zones.length) { dock.hidden = true; return; }
      var last = zones[zones.length - 1];
      var railBottom = rail.getBoundingClientRect().bottom + window.pageYOffset;
      var zoneEnd = last.getBoundingClientRect().bottom + window.pageYOffset;
      var y = window.pageYOffset, vh = window.innerHeight;
      var show = (y + 80 > railBottom) && (y + vh * 0.6 < zoneEnd);
      dock.hidden = !show;
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(place); } }
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    setTimeout(place, 300);
  }

  /* ---------- the buy box: 1 / 2 / 3, one-time or subscribe ---------- */
  var buy = $("[data-buy]");
  if (buy) {
    var form = buy.closest("form");
    var qtyInput = $("[data-pdp-qty-input]", form);
    var planInput = $("[data-plan-input]", form);
    var addBtn = $("[data-add]", form);
    var cfg = {};
    try { cfg = JSON.parse(($("[data-buy-config]") || {}).textContent || "{}"); } catch (e) {}

    function num(v, d) { var n = parseFloat(v); return isNaN(n) ? d : n; }
    function state() {
      var q = num((form.querySelector("[data-tier-input]:checked") || {}).value, 1);
      var pt = (form.querySelector("[data-ptype-input]:checked") || {}).value || "once";
      return { q: q, sub: pt === "sub" };
    }
    function calc() {
      var st = state();
      var base = num(buy.dataset.base, 0), t2 = num(buy.dataset.t2, 0), t3 = num(buy.dataset.t3, 0), subPct = num(buy.dataset.sub, 0);
      var unitS = buy.dataset.unitS || "pouch", unitP = buy.dataset.unitP || unitS + "s";
      var saveWord = buy.dataset.saveWord || "Save", eachWord = buy.dataset.eachWord || "each";
      var sub = st.sub ? subPct : 0;
      function priceFor(q) {
        var tier = q === 2 ? t2 : q === 3 ? t3 : 0;
        var unitSub = Math.round(base * (1 - sub / 100));     // the plan's price, per unit
        var line = unitSub * q;
        var disc = Math.round(line * tier / 100);              // the quantity discount, on the line
        return { total: line - disc, was: base * q, tier: tier };
      }
      [1, 2, 3].forEach(function (q) {
        var p = priceFor(q);
        var each = $("[data-tier-each=\"" + q + "\"]", buy), save = $("[data-tier-save=\"" + q + "\"]", buy);
        if (each) each.textContent = money(Math.round(p.total / q)) + " " + eachWord;
        if (save) {
          var pct = p.was ? Math.round((1 - p.total / p.was) * 100) : 0;
          save.textContent = pct > 0 ? saveWord + " " + pct + "%" : "";
        }
      });
      var once = $("[data-once-price]", buy), subEl = $("[data-sub-price]", buy);
      if (once) { var s1 = (function () { var keep = sub; sub = 0; var r = priceFor(st.q); sub = keep; return r; })(); once.textContent = money(Math.round(s1.total / st.q)) + " " + eachWord; }
      if (subEl) { var s2 = (function () { var keep = sub; sub = subPct; var r = priceFor(st.q); sub = keep; return r; })(); subEl.textContent = money(Math.round(s2.total / st.q)) + " " + eachWord; }
      var p = priceFor(st.q);
      var lab = $("[data-total-label]", buy), tot = $("[data-total]", buy), was = $("[data-total-was]", buy), line = $("[data-save-line]", buy);
      if (lab) lab.textContent = st.q + " " + (st.q === 1 ? unitS : unitP) + (st.sub ? " · subscription" : "");
      if (tot) tot.textContent = money(p.total);
      if (was) { was.hidden = p.total >= p.was; was.textContent = money(p.was); }
      if (line) { var saved = p.was - p.total; line.hidden = saved <= 0; line.textContent = saved > 0 ? "You " + saveWord.toLowerCase() + " " + money(saved) + (st.sub ? " on every delivery" : " today") : ""; }
      if (qtyInput) qtyInput.value = String(st.q);
      if (planInput) planInput.disabled = !st.sub;
      if (addBtn && !addBtn.disabled) addBtn.textContent = (addBtn.dataset.addLabel || "Add to cart") + " · " + money(p.total);
    }
    form.addEventListener("change", function (e) {
      if (e.target.matches("[data-tier-input],[data-ptype-input]")) calc();
    });
    document.addEventListener("ig:variant", function (e) { buy.dataset.base = String(e.detail.price); calc(); });
    calc();

    // after adding: go to the bag, where the savings show, unless told to stay
    form.addEventListener("submit", function () {
      form.dataset.after = cfg.after || "cart";
    }, true);
  }

  /* ---------- the Supplement Facts drawer ---------- */
  var drawer = $("[data-facts-drawer]");
  var openers = $$("[data-facts-open]");
  if (drawer && !drawer.querySelector("[data-nfx-panel]")) drawer = null;
  if (drawer) {
    openers.forEach(function (b) { b.hidden = false; });
    var lastFocus = null, closing = null;
    function openDrawer() {
      clearTimeout(closing);
      lastFocus = document.activeElement;
      drawer.hidden = false;
      document.body.classList.add("has-drawer");
      setTimeout(function () { drawer.classList.add("is-open"); }, 30);
      setTimeout(function () { var p = $(".fdrawer__panel", drawer); if (p) p.focus({ preventScroll: true }); }, 120);
    }
    function closeDrawer() {
      drawer.classList.remove("is-open");
      document.body.classList.remove("has-drawer");
      closing = setTimeout(function () { drawer.hidden = true; }, 480);
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
    document.addEventListener("click", function (e) {
      if (e.target.closest && e.target.closest("[data-facts-open]")) { e.preventDefault(); openDrawer(); }
      else if (e.target.closest && e.target.closest("[data-facts-close]")) { e.preventDefault(); closeDrawer(); }
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !drawer.hidden) closeDrawer(); });
  } else {
    openers.forEach(function (b) { b.hidden = true; });
  }

  /* ---------- swipe rows: a cue that follows the scroll on phones — dots, a hairline bar, or an editorial counter ---------- */
  $$("[data-swipe]").forEach(function (row) {
    var ui = (row.nextElementSibling && row.nextElementSibling.hasAttribute("data-swipe-dots")) ? row.nextElementSibling : (row.parentElement && row.parentElement.querySelector("[data-swipe-dots]"));
    if (!ui) return;
    var kids = Array.prototype.slice.call(row.children);
    if (kids.length < 2) return;
    var kind = ui.getAttribute("data-swipe-ui") || "dots";
    var pad = function (n) { return (n < 10 ? "0" : "") + n; };
    var thumb = null, num = null, ds = [];
    if (kind === "bar") {
      ui.className = "m-bar";
      ui.innerHTML = '<span class="m-bar__track"><i></i></span>';
      thumb = ui.querySelector("i");
    } else if (kind === "count") {
      ui.className = "m-count";
      ui.innerHTML = '<span class="m-count__n">01</span><span class="m-count__track"><i></i></span><span class="m-count__t">' + pad(kids.length) + '</span>';
      thumb = ui.querySelector("i");
      num = ui.querySelector(".m-count__n");
    } else {
      ui.innerHTML = kids.map(function () { return "<span></span>"; }).join("");
      ds = $$("span", ui);
    }
    function mark() {
      var max = row.scrollWidth - row.clientWidth;
      if (kind !== "dots") ui.hidden = max < 8;
      var x = row.scrollLeft + row.clientWidth / 2, best = 0, bd = Infinity;
      kids.forEach(function (k, i) { var c = k.offsetLeft + k.offsetWidth / 2, d = Math.abs(c - x); if (d < bd) { bd = d; best = i; } });
      ds.forEach(function (d, i) { d.classList.toggle("is-on", i === best); });
      if (num) num.textContent = pad(best + 1);
      if (thumb && max >= 8) {
        var frac = Math.min(1, Math.max(0, row.scrollLeft / max));
        var w = Math.max(0.22, Math.min(1, row.clientWidth / row.scrollWidth));
        thumb.style.width = (w * 100).toFixed(2) + "%";
        thumb.style.transform = "translateX(" + (frac * (1 - w) / w * 100).toFixed(2) + "%)";
      }
    }
    row.addEventListener("scroll", function () { requestAnimationFrame(mark); }, { passive: true });
    window.addEventListener("resize", mark);
    if ("ResizeObserver" in window) new ResizeObserver(function () { mark(); }).observe(row);
    mark();
  });
})();

/* ============================================================
   GLOWPOP v4.17 — the announcement bar takes turns through its phrases
   ============================================================ */
(function () {
  "use strict";
  var bars = Array.prototype.slice.call(document.querySelectorAll("[data-ann]"));
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  bars.forEach(function (bar) {
    if (!bar.classList.contains("ann--rotate")) return;
    var items = Array.prototype.slice.call(bar.querySelectorAll(".ann__item"));
    if (items.length < 2 || reduce) return;
    var every = Math.max(3, parseFloat(bar.getAttribute("data-ann-every")) || 5) * 1000;
    var i = 0, timer = null, paused = false;
    function show(n) {
      items.forEach(function (it, k) { it.classList.toggle("is-on", k === n); });
    }
    function tick() { if (!paused) { i = (i + 1) % items.length; show(i); } }
    function start() { clearInterval(timer); timer = setInterval(tick, every); }
    bar.addEventListener("mouseenter", function () { paused = true; });
    bar.addEventListener("mouseleave", function () { paused = false; });
    document.addEventListener("visibilitychange", function () { if (document.hidden) clearInterval(timer); else start(); });
    start();
  });
})();

/* product pages: whichever column is shorter stays in view; a column taller than the screen
   sticks by its bottom edge instead, so nothing is ever cut off */
(function () {
  "use strict";
  var cols = Array.prototype.slice.call(document.querySelectorAll(".pdp > *"));
  if (!cols.length) return;
  function place() {
    var wide = window.matchMedia("(min-width: 881px)").matches;
    cols.forEach(function (c) {
      if (!wide) { c.style.top = ""; return; }
      var h = c.offsetHeight, room = window.innerHeight - 24;
      c.style.top = (h + 96 > room ? Math.round(room - h) : 96) + "px";
    });
  }
  place();
  window.addEventListener("resize", place);
  window.addEventListener("load", place);
  if (window.ResizeObserver) { var ro = new ResizeObserver(place); cols.forEach(function (c) { ro.observe(c); }); }
})();


/* ============================================================
   GLOWPOP v4.21 — the phone layout: swipe rows (edge fade, one gentle nudge),
   and the folds ("Read more", "See the full label")
   ============================================================ */
(function () {
  "use strict";
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var phone = window.matchMedia("(max-width: 760px)");

  /* ---------- swipe rows ---------- */
  $$(".m-swipe, .m-scroll").forEach(function (row) {
    function edge() { row.classList.toggle("is-end", row.scrollLeft + row.clientWidth >= row.scrollWidth - 4); }
    row.addEventListener("scroll", function () { requestAnimationFrame(edge); }, { passive: true });
    window.addEventListener("resize", edge);
    edge();
    if (!("IntersectionObserver" in window)) return;
    var nudged = false;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        edge();
        // the first time the row comes into view it slides a little and settles back: "you can swipe this"
        var need = Math.min(0.6, (window.innerHeight * 0.45) / Math.max(1, row.offsetHeight));
        if (nudged || reduce || !phone.matches || e.intersectionRatio < need || row.scrollLeft > 0 || row.scrollWidth <= row.clientWidth + 8) return;
        nudged = true;
        io.unobserve(row);
        setTimeout(function () {
          if (row.scrollLeft > 0) return;
          var start = null, dist = 28, dur = 1000, snap = row.style.scrollSnapType;
          row.style.scrollSnapType = "none";
          function step(t) {
            if (!start) start = t;
            var p = Math.min(1, (t - start) / dur);
            row.scrollLeft = dist * Math.sin(p * Math.PI);
            if (p < 1) requestAnimationFrame(step); else { row.scrollLeft = 0; row.style.scrollSnapType = snap; edge(); }
          }
          requestAnimationFrame(step);
        }, 500);
      });
    }, { threshold: [0.15, 0.3, 0.45, 0.6] });
    io.observe(row);
  });

  /* ---------- folds ---------- */
  $$("[data-fold]").forEach(function (box) {
    var btn = box.parentElement.querySelector("[data-fold-btn]");
    if (!btn) return;
    var more = btn.textContent, less = btn.getAttribute("data-less") || more;
    function check() {
      if (!phone.matches) { btn.hidden = true; return; }
      var open = box.classList.contains("is-open");
      btn.hidden = !open && box.scrollHeight <= box.clientHeight + 16;
    }
    btn.addEventListener("click", function () {
      var open = box.classList.toggle("is-open");
      btn.textContent = open ? less : more;
      btn.setAttribute("aria-expanded", String(open));
      if (!open) { var top = box.getBoundingClientRect().top; if (top < 0) window.scrollBy({ top: top - 120, behavior: reduce ? "auto" : "smooth" }); }
    });
    window.addEventListener("resize", check);
    // a label that was hidden when the page loaded (another product's panel) is measured again the moment it is shown
    if ("ResizeObserver" in window) new ResizeObserver(function () { check(); }).observe(box);
    check();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(check);
  });
})();

/* v4.23: product titles never let a single long word ("Supplements", "Electrolyte") run out of the buy box —
   the heading shrinks only as far as that word needs, and only on the products that need it. */
(function () {
  var t = document.querySelector('.pdp__title'); if (!t) return;
  function fit() {
    t.style.fontSize = '';
    var fs = parseFloat(getComputedStyle(t).fontSize), min = fs * 0.6, n = 0;
    while (t.scrollWidth > t.clientWidth + 1 && fs > min && n++ < 30) { fs = fs * 0.96; t.style.fontSize = fs + 'px'; }
  }
  fit();
  var to; window.addEventListener('resize', function () { clearTimeout(to); to = setTimeout(fit, 120); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
})();

/* ---------- v4.34 — 'Not to be dramatic': fit the photo column to the photo (desktop) ----------
   Desktop only. Sizes the photo column to the picture's own proportions so the whole photo shows
   at its natural aspect ratio with no crop and no empty band beside or above it. */
(function () {
  var MQ = window.matchMedia('(min-width: 900px)');
  var MINF = 0.32;          /* photo column never narrower than this share of the section */
  var COPY_MIN = 560;       /* leave the words at least this much room */
  var MAXF = 0.66;          /* photo column never wider than this share of the section */
  var busy = false, runs = 0, since = 0;

  function ratio(sec) {
    var v = getComputedStyle(sec).getPropertyValue('--truth-ar').trim();
    var p = v.split('/');
    if (p.length === 2) { var a = parseFloat(p[0]), b = parseFloat(p[1]); if (a > 0 && b > 0) return a / b; }
    var img = sec.querySelector('.truth__media img');
    if (img) {
      var w = img.naturalWidth || parseFloat(img.getAttribute('width'));
      var h = img.naturalHeight || parseFloat(img.getAttribute('height'));
      if (w > 0 && h > 0) return w / h;
    }
    return 0;
  }

  function baseH(sec) {
    var v = getComputedStyle(sec).getPropertyValue('--truth-h').trim();
    var n = parseFloat(v);
    if (!n) return 0;
    if (v.indexOf('px') > -1) return n;
    return n / 100 * window.innerHeight;
  }

  function fit(sec) {
    var media = sec.querySelector('.truth__media');
    var copy = sec.querySelector('.truth__copy');
    var inner = sec.querySelector('.truth__copy-in');
    if (!media || !copy || !inner) return;
    if (!MQ.matches) { sec.style.removeProperty('--truth-col'); sec.style.removeProperty('--truth-minh'); return; }
    var W = sec.clientWidth;
    var ar = ratio(sec);
    if (!W || !ar) return;
    var cs = getComputedStyle(copy);
    var pad = parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom);
    var hi = Math.min(W * MAXF, Math.max(W - COPY_MIN, W * MINF));
    var lo = Math.min(W * MINF, hi);
    for (var i = 0; i < 3; i++) {
      var need = inner.getBoundingClientRect().height + pad;
      if (!need) return;
      var h = Math.max(need, baseH(sec));
      var w = Math.min(hi, Math.max(lo, h * ar));
      var cur = parseFloat(sec.style.getPropertyValue('--truth-col')) || 0;
      if (Math.abs(cur - w) < 0.5) return;
      sec.style.setProperty('--truth-col', w.toFixed(1) + 'px');
      sec.style.setProperty('--truth-minh', (w / ar).toFixed(1) + 'px');
    }
  }

  function all() {
    if (busy) return;
    var now = Date.now();
    if (now - since > 2000) { since = now; runs = 0; }
    if (++runs > 40) return;               /* safety valve */
    busy = true;
    try {
      var list = document.querySelectorAll('.truth--bleed');
      for (var i = 0; i < list.length; i++) { try { fit(list[i]); } catch (e) {} }
    } finally { busy = false; }
  }

  var to, to2;
  function later() {
    clearTimeout(to); to = setTimeout(all, 60);
    clearTimeout(to2); to2 = setTimeout(all, 320);
  }
  all();
  if (window.MutationObserver) {
    new MutationObserver(later).observe(document.documentElement, { attributes: true, attributeFilter: ['data-world'] });
  }
  window.addEventListener('resize', later);
  window.addEventListener('load', later);
  window.addEventListener('pageshow', later);
  document.addEventListener('click', function (e) { if (e.target && e.target.closest && e.target.closest('[data-world-pick]')) later(); }, true);
  document.addEventListener('shopify:section:load', later);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(later);
  if (window.ResizeObserver) {
    var ro = new ResizeObserver(later);
    var secs = document.querySelectorAll('.truth--bleed');
    for (var j = 0; j < secs.length; j++) {
      ro.observe(secs[j]);
      var inn = secs[j].querySelector('.truth__copy-in');
      if (inn) ro.observe(inn);
    }
  }
})();


/* ============================================================
   v4.36 — back to top: parks in a free spot of the footer, rises in when
   the footer arrives, scrolls smoothly home (instantly with reduced motion)
   and hands keyboard focus back to the top of the page.
   ============================================================ */
(function () {
  var btn = document.querySelector('[data-btt]');
  if (!btn) return;
  var foot = btn.parentElement;
  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var SEL = 'p,h1,h2,h3,h4,h5,h6,a,span,label,input,button,select,textarea,img,svg,iframe,small,strong,em,b,i';

  function rectsOf(el) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA|IMG|IFRAME)$/.test(el.tagName) || (window.SVGElement && el instanceof SVGElement)) return [el.getBoundingClientRect()];
    try { var rg = document.createRange(); rg.selectNodeContents(el); return Array.prototype.slice.call(rg.getClientRects()); }
    catch (e) { return [el.getBoundingClientRect()]; }
  }

  function place() {
    var fr = foot.getBoundingClientRect();
    if (!fr.width) return;
    var wrap = foot.querySelector('.wrap') || foot;
    var wr = wrap.getBoundingClientRect();
    var size = btn.offsetWidth || 52;
    var inset = Math.max(12, Math.round(fr.right - (wr.right - (parseFloat(getComputedStyle(wrap).paddingRight) || 0))));
    var laneL = fr.width - inset - size - 10, laneR = fr.width - inset + 6;
    var obs = [], list = foot.querySelectorAll(SEL);
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      if (btn === el || btn.contains(el)) continue;
      var rs = rectsOf(el);
      for (var j = 0; j < rs.length; j++) {
        var r = rs[j];
        if (r.width < 1 || r.height < 1) continue;
        if (r.right - fr.left < laneL || r.left - fr.left > laneR) continue;
        obs.push([r.top - fr.top, r.bottom - fr.top]);
      }
    }
    function free(top) {
      var a = top - 8, b = top + size + 8;
      for (var k = 0; k < obs.length; k++) if (obs[k][1] > a && obs[k][0] < b) return false;
      return true;
    }
    var top = null, logo = foot.querySelector('.logo');
    if (logo) {
      var lr = logo.getBoundingClientRect();
      var t1 = Math.round((lr.top + lr.bottom) / 2 - fr.top - size / 2);
      if (t1 >= 8 && free(t1)) top = t1;
    }
    if (top === null) {
      var padTop = parseFloat(getComputedStyle(foot).paddingTop) || 0;
      var t2 = Math.round((padTop - size) / 2);
      if (t2 >= 6 && free(t2)) top = t2;
    }
    if (top === null) {
      for (var t = 8; t < fr.height - size - 8; t += 6) { if (free(t)) { top = t; break; } }
    }
    if (top === null) top = -Math.round(size / 2);
    btn.style.setProperty('--btt-top', top + 'px');
    btn.style.setProperty('--btt-right', inset + 'px');
  }

  var timer;
  function later() { clearTimeout(timer); timer = setTimeout(place, 120); }
  place();
  window.addEventListener('load', place);
  window.addEventListener('resize', later);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(place);
  setTimeout(place, 1500);

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { btn.classList.toggle('is-in', en.isIntersecting); });
    }, { rootMargin: '0px 0px -16px 0px', threshold: 0.6 }).observe(btn);
  } else {
    btn.classList.add('is-in');
  }

  btn.addEventListener('click', function (e) {
    e.preventDefault();
    var fromKeyboard = e.detail === 0;
    try { window.scrollTo({ top: 0, left: 0, behavior: reduce.matches ? 'instant' : 'smooth' }); }
    catch (err) { window.scrollTo(0, 0); }
    if (fromKeyboard) {
      var target = document.querySelector('a.sr-only[href="#top"]') || document.querySelector('header a[href], header button');
      if (target) { try { target.focus({ preventScroll: true }); } catch (err2) { target.focus(); } }
    } else {
      btn.blur();
    }
  });
})();
